import type { KyInstance } from "ky";

import { getLeaderboardTimeframe } from "./getLeaderboardTimeframe";

export interface TechSupportMetrics {
    totalCalls?: number;
    callResolutionTime?: number;
    oneCallResolution?: number;
    resolutionRate?: number;
    transferRate?: number;
    perfectSurveys?: number;
    fiveStarRating?: number;
    entireRepPerformance?: number;
    salesPer100?: number;
    cancellationRate?: number;
    netEnrolls?: number;
    totalCallsLastUpdated?: string;
    callResolutionTimeLastUpdated?: string;
    oneCallResolutionLastUpdated?: string;
    resolutionRateLastUpdated?: string;
    transferRateLastUpdated?: string;
    perfectSurveysLastUpdated?: string;
    fiveStarRatingLastUpdated?: string;
    entireRepPerformanceLastUpdated?: string;
    salesPer100LastUpdated?: string;
    cancellationRateLastUpdated?: string;
    netEnrollsLastUpdated?: string;
}

interface Employee {
    metrics?: {
        techSupport?: TechSupportMetrics;
    };
}

export const getPerformanceMetrics = async (client: KyInstance): Promise<TechSupportMetrics | null> => {
    const { start, end } = getLeaderboardTimeframe();

    const resp = await client
        .get(`v1/performance?start=${start}&end=${end}`, { retry: 0 })
        .json<{ employee: Employee }>();

    return resp.employee.metrics?.techSupport ?? null;
};
